export default __webpack_public_path__ + "static/media/loader.334cdf21.gif";